import CommonDatePicker from "@/common/elements/DatePicker";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import SecureFormItem from "@/common/SecureFormItem";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { SCHEMA_NAME } from "@/util/common_variable";
import { Button, Form } from "antd";
import { useEffect } from "react";

const EquipmentsModal = ({
  show,
  handleCancel,
  formSubmit,
  selectStaffProperty,
  bookingsFieldsEnabled = true,
  startingPoint,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectStaffProperty)) {
      form.setFieldsValue(selectStaffProperty);
    } else {
      form.resetFields();
    }
  }, [selectStaffProperty]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        dateAssigned: isNonEmptyVariable(values?.dateAssigned)
          ? values?.dateAssigned?.format("MM/DD/YYYY")
          : null,
        dateReturned: isNonEmptyVariable(values?.dateReturned)
          ? values?.dateReturned?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };

  function handleFormCancel() {
    handleCancel();
    form.resetFields();
  }
  return (
    <>
      <Modal
        show={show}
        handleCancel={handleFormCancel}
        onHide={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="75%"
        header={`${
          selectStaffProperty ? "VIEW" : "ADD"
        } Items Assigned To Staff Member`}
        footerActions={[
          <Button
            key="SUBMIT"
            onClick={handleFormCancel}
            disabled={!bookingsFieldsEnabled}
          >
            Close
          </Button>,
          <Button
            key="SUBMIT"
            onClick={handleSubmit}
            disabled={!bookingsFieldsEnabled}
          >
            Save
          </Button>,
        ]}
      >
        <FieldSecurityProvider
          entity={SCHEMA_NAME.STAFF_PROPERTY}
          startingPoint={startingPoint}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        >
          <Form form={form} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="categoryID"
                  formItemProps={{ name: "categoryID", label: "Category" }}
                >
                  <Select
                    id="propertyCategory"
                    options={getOptionsFromRefList(
                      "StaffProperty_Category",
                      false,
                      false,
                      true,
                    )}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="productID"
                  formItemProps={{ name: "productID", label: "Product" }}
                >
                  <Select
                    id="product"
                    options={getOptionsFromRefList(
                      "StaffProperty_Product",
                      false,
                      false,
                      true,
                    )}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={8}>
                <SecureFormItem
                  fieldName={[
                    "propertyWithSerialNumberRequest",
                    0,
                    "manufacturer",
                  ]}
                  formItemProps={{
                    name: [
                      "propertyWithSerialNumberRequest",
                      0,
                      "manufacturer",
                    ],
                    label: "Manufacturer",
                  }}
                  entityOverride={SCHEMA_NAME.PROPERTY_WITH_SERIAL_NUMBER}
                >
                  <TextField id="manufacturer" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={8}>
                <SecureFormItem
                  fieldName={["propertyWithSerialNumberRequest", 0, "model"]}
                  formItemProps={{
                    name: ["propertyWithSerialNumberRequest", 0, "model"],
                    label: "Model",
                  }}
                  entityOverride={SCHEMA_NAME.PROPERTY_WITH_SERIAL_NUMBER}
                >
                  <TextField id="model" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={8}>
                <SecureFormItem
                  fieldName="colorID"
                  formItemProps={{ name: "colorID", label: "Color" }}
                >
                  <Select
                    id="color"
                    options={getOptionsFromRefList(
                      "PropertyColor",
                      false,
                      false,
                      true,
                    )}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName={[
                    "propertyWithSerialNumberRequest",
                    0,
                    "serialNumber",
                  ]}
                  formItemProps={{
                    name: [
                      "propertyWithSerialNumberRequest",
                      0,
                      "serialNumber",
                    ],
                    label: "Serial Number",
                  }}
                  entityOverride={SCHEMA_NAME.PROPERTY_WITH_SERIAL_NUMBER}
                >
                  <TextField id="serialNumber" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <SecureFormItem
                  fieldName="cost"
                  formItemProps={{ name: "cost", label: "Cost" }}
                >
                  <TextField id="cost" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={24}>
                <SecureFormItem
                  fieldName="description"
                  formItemProps={{ name: "description", label: "Description" }}
                >
                  <TextField id="description" inputType="textarea" />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={8}>
                <SecureFormItem
                  fieldName="assignedByStaffID"
                  formItemProps={{
                    name: "assignedByStaffID",
                    label: "Assigned By",
                  }}
                >
                  <Select
                    id="assignedBy"
                    options={getOptionsFromRefList("", true, false, true)}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <SecureFormItem
                  fieldName="dateAssigned"
                  formItemProps={{
                    name: "dateAssigned",
                    label: "Date Assigned",
                  }}
                >
                  <CommonDatePicker
                    id="dateAssigned"
                    format="MM/DD/YYYY"
                    showTime={false}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={4}>
                <SecureFormItem
                  fieldName="quantity"
                  formItemProps={{ name: "quantity", label: "Quantity" }}
                >
                  <TextField id="quantity" type="number" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <SecureFormItem
                  fieldName="statusID"
                  formItemProps={{ name: "statusID", label: "Status" }}
                >
                  <Select
                    id="status"
                    options={getOptionsFromRefList(
                      "StaffProperty_Status",
                      false,
                      false,
                      true,
                    )}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="returnedToStaffID"
                  formItemProps={{
                    name: "returnedToStaffID",
                    label: "Returned To",
                  }}
                >
                  <Select
                    id="returnedTo"
                    options={getOptionsFromRefList("", true, false, true)}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <SecureFormItem
                  fieldName="dateReturned"
                  formItemProps={{
                    name: "dateReturned",
                    label: "Date Returned",
                  }}
                >
                  <CommonDatePicker
                    id="dateReturned"
                    format="MM/DD/YYYY"
                    showTime={false}
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </FieldSecurityProvider>
      </Modal>
    </>
  );
};

export default EquipmentsModal;
